import { ALINEA_PROFILES, QUIT_THOUGHT } from './constants.js';
import { calcEnneagram, calcHumanDesign, ENNEAGRAM_TYPES, HD_TYPES } from './enneagramHd.js';

const PROFILE_KEYS = ['constante', 'impulsivo', 'analitico', 'social'];

export function buildManadaInsights(employees = []) {
    const profiles = { constante: 0, impulsivo: 0, analitico: 0, social: 0, sin_perfil: 0 };
    const enneagramDist = {};
    const hdDist = {};
    const huidaAlto = [];
    const huidaMedio = [];
    let sinEncuestaSemanal = 0;

    for (const emp of employees) {
        const p = (emp.profile_type || '').toLowerCase();
        if (PROFILE_KEYS.includes(p)) profiles[p]++;
        else profiles.sin_perfil++;

        const enne =
            emp.enneagram_number || calcEnneagram(emp.birth_date);
        if (enne) enneagramDist[enne] = (enneagramDist[enne] || 0) + 1;

        const hd = calcHumanDesign(emp.birth_date);
        if (hd) hdDist[hd] = (hdDist[hd] || 0) + 1;

        const quit = emp.thought_of_quitting;
        const row = {
            id: emp.id,
            nombre: emp.nombre || emp.full_name,
            area: emp.area,
            profile_type: p,
        };
        if (quit === 'si_mucho') huidaAlto.push(row);
        else if (quit === 'a_veces') huidaMedio.push(row);
        else if (!quit) sinEncuestaSemanal++;
    }

    const n = employees.length || 1;
    const radarData = PROFILE_KEYS.map((k) => profiles[k]);
    const archetypeBars = PROFILE_KEYS.map((k) => ({
        key: k,
        count: profiles[k],
        pct: Math.round((profiles[k] / n) * 100),
        ...ALINEA_PROFILES[k],
    }));

    return {
        total: employees.length,
        profiles,
        radarData,
        archetypeBars,
        enneagramDist,
        hdDist,
        huidaAlto,
        huidaMedio,
        sinEncuestaSemanal,
        huidaPctAlto: employees.length ? Math.round((huidaAlto.length / employees.length) * 100) : 0,
    };
}

export function quitLabel(key) {
    return QUIT_THOUGHT[key]?.label || 'Sin dato reciente';
}

export function quitEmoji(key) {
    return QUIT_THOUGHT[key]?.emoji || '·';
}
